import React from 'react'
import BenefitThumb from './BenefitThumb'

class BenefitThumbView extends React.Component {
  componentDidMount () {
    this.resizeBenefitImage()
  }
  
  componentDidUpdate () {
    this.resizeBenefitImage()
  }
    
  resizeBenefitImage () {
    $.each($('.benefit-item'), function() {
      const titleHeight = $(this).find('.item-title').outerHeight();
      const imageHeight = 300 - titleHeight;
      return $(this).find('.benefit-image-div')[0].style.height = imageHeight + 'px';
    });
  }

  render () {
    return (
      <div>
        { this.props.leave_benefits.map( (benefit, i) => {
          return(<BenefitThumb
            key={benefit.id}
            benefit={benefit}
            handleOnClick={this.props.handleOnClick}
            themes={this.props.themes}
          />)  
        })}
      </div>
    )
  }

}
export default BenefitThumbView
